// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"be139a52","91":"5f97a5f1","132":"040f295a","135":"fc40da5b","193":"7080da1a","618":"fc40da5b","924":"fc40da5b"}[chunkId] + ".chunk.css";
};